import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { CrmApp } from "@/pages/CrmApp";

export default function App() { return <BrowserRouter><CrmApp /></BrowserRouter>; }
